module.exports = __webpack_public_path__ + "media/剖面--楼座面积.ec37b88e.mp4";